import { render, staticRenderFns } from "./contentleads.vue?vue&type=template&id=67b6e068"
import script from "./contentleads.vue?vue&type=script&lang=js"
export * from "./contentleads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports